/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import React from 'react';
import { styled } from '@mui/material/styles';
import MuiBox from '@mui/material/Box';

const Box = styled((props) => <MuiBox {...props} />)(({...props}) => ({
	height: props.preview ? '100%' : `calc(100% - ${53 + props.topSpace}px)`,
	padding: props.preview ? '0px' : `${props.topSpace}px 16px ${props.bottomSpace}px 16px`,
	display: 'inline-flex',
	width: '100%',
}));

export default function StreamSheetPaper(props) {
	return (
		<Box {...props} />
	);
}

StreamSheetPaper.defaultProps = {
	topSpace: 16,
	bottomSpace: 16,
};
